import React from "react";
import * as Sentry from "@sentry/react";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { useTranslation } from "react-i18next";

const ErrorFallback: React.FC<{
  error: Error;
  resetError: () => void;
}> = ({ error, resetError }) => {
  const { t } = useTranslation();

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      minHeight="60vh"
      px={3}
      textAlign="center"
    >
      <Typography variant="h5" gutterBottom>
        {t("errorBoundary.heading")}
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
        {t("errorBoundary.body")}
      </Typography>
      <Box display="flex" gap={2}>
        <Button variant="contained" onClick={resetError}>
          {t("errorBoundary.tryAgain")}
        </Button>
        <Button
          variant="outlined"
          onClick={() => {
            window.location.href = "/";
          }}
        >
          {t("errorBoundary.goHome")}
        </Button>
      </Box>
    </Box>
  );
};

const AppErrorBoundary: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  return (
    <Sentry.ErrorBoundary
      fallback={({ error, resetError }) => (
        <ErrorFallback error={error as Error} resetError={resetError} />
      )}
    >
      {children}
    </Sentry.ErrorBoundary>
  );
};

export default AppErrorBoundary;
